<form [formGroup]="changePasswordForm" class="login-container change">
  <div class="header">
    <span>Change Your Password</span>
  </div>
  <div class="subheader">
    Please enter the current password associated with the account for
    <strong>{{ currentUser ? currentUser.email : '' }}</strong>
    . Then create a new password and confirm your new password to continue.
  </div>
  <mat-form-field class="w-100-1">
    <mat-label>Current Password</mat-label>
    <input [type]="showCurrentPassword ? 'text' : 'password'" formControlName="currentPassword" matInput required />
    <mat-icon (click)="showCurrentPassword = !showCurrentPassword" class="password-visibility" matSuffix>
      @if (showCurrentPassword) {
        <fa-icon [icon]="['fas', 'eye-slash']" class="dark-gray"></fa-icon>
      } @else {
        <fa-icon [icon]="['fas', 'eye']" class="dark-gray"></fa-icon>
      }
    </mat-icon>
  </mat-form-field>
  <mat-form-field class="w-100-1">
    <mat-label>New Password</mat-label>
    <input [type]="showNewPassword ? 'text' : 'password'" formControlName="newPassword" matInput required />
    <mat-icon (click)="showNewPassword = !showNewPassword" class="password-visibility" matSuffix>
      @if (showNewPassword) {
        <fa-icon [icon]="['fas', 'eye-slash']" class="dark-gray"></fa-icon>
      } @else {
        <fa-icon [icon]="['fas', 'eye']" class="dark-gray"></fa-icon>
      }
    </mat-icon>
  </mat-form-field>
  <mat-form-field class="w-100-1">
    <mat-label>Confirm Password</mat-label>
    <input [type]="showVerifyPassword ? 'text' : 'password'" formControlName="verifyPassword" matInput required />
    <mat-icon (click)="showVerifyPassword = !showVerifyPassword" class="password-visibility" matSuffix>
      @if (showVerifyPassword) {
        <fa-icon [icon]="['fas', 'eye-slash']" class="dark-gray"></fa-icon>
      } @else {
        <fa-icon [icon]="['fas', 'eye']" class="dark-gray"></fa-icon>
      }
    </mat-icon>
  </mat-form-field>
  @if (errorMessage) {
    <mat-error>{{ errorMessage }}</mat-error>
  }
  @if (
    changePasswordForm.hasError('passwordMismatch') &&
    changePasswordForm.controls.newPassword.dirty &&
    changePasswordForm.controls.verifyPassword.dirty
  ) {
    <mat-error>Passwords do not match</mat-error>
  }
  @if (
    (changePasswordForm.controls.newPassword.hasError('security') && changePasswordForm.controls.newPassword.dirty) ||
    (changePasswordForm.controls.verifyPassword.hasError('security') &&
      changePasswordForm.controls.verifyPassword.dirty)
  ) {
    <mat-error>
      Your password is required to be at least 8 characters long and contain at least 1 uppercase letter and 1 number
    </mat-error>
  }
  <div class="button-container">
    <button (click)="redirect()" color="primary" mat-stroked-button type="button">Cancel</button>
    <button (click)="changePassword()" [disabled]="!changePasswordForm.valid" color="primary" mat-raised-button>
      Set New Password
    </button>
  </div>
</form>
